import  {__extends} from './eXcell';
import eXcell_ed from './eXcell_ed';

var eXcell_icon = (function (_super) {
    __extends(eXcell_icon, _super);
    function eXcell_icon(a) {
        _super.call(this, a);
        try {
            this.cell = a;
            this.grid = this.cell.parentNode.grid;
        }
        catch (c) {
            console&&console.log(c);
        }
    }
    eXcell_icon.prototype.setValue = function (e) {
        this.cell._raw_value = e;
        this.setCValue(`<div class="dhx_grid_icon"><i class="${e}" title="${e}"></i></div>`);
    };
    eXcell_icon.prototype.getValue = function () {
        return this.cell._raw_value;
    };
    eXcell_icon.prototype.isDisabled = function () {
        return true;
    };
    return eXcell_icon;
})(eXcell_ed);
window.eXcell_icon = eXcell_icon;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell_icon.js